import React from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import { Nav, Row, Col } from 'react-bootstrap';

import PicklistShipments from 'components/add_order/picklist/PicklistDetail/PicklistShipments';
import PicklistProducts from 'components/add_order/picklist/PicklistDetail/PicklistProducts';
import PicklistDetailSummary from 'components/add_order/picklist/PicklistDetail/PicklistDetailSummary';

const PicklistDetail = () => {
  const { picklistId } = useParams();
  const [searchParams, setSearchParams] = useSearchParams();
  const activeTab = searchParams.get('tab') || 'shipments';
  const [isAllScanned, setIsAllScanned] = React.useState(false);

  const handleSelect = tab => {
    setSearchParams({ tab });
  };

  return (
    <Row className="mt-1">
      <Col md={9} className="mb-3 mb-md-0">
        <Nav variant="tabs" className="mb-3">
          <Nav.Item>
            <Nav.Link
              active={activeTab === 'shipments'}
              onClick={() => handleSelect('shipments')}
            >
              Shipment
            </Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link
              active={activeTab === 'items'}
              onClick={() => handleSelect('items')}
            >
              Items
            </Nav.Link>
          </Nav.Item>
        </Nav>

        {activeTab === 'shipments' && (
          <PicklistShipments picklistId={picklistId} />
        )}
        {activeTab === 'items' && (
          <PicklistProducts
            picklistId={picklistId}
            onScanStatusChange={setIsAllScanned}
          />
        )}
      </Col>

      <Col md={3}>
        <PicklistDetailSummary
          picklistId={picklistId}
          showActionBtn={true}
          isAllScanned={isAllScanned}
        />
      </Col>
    </Row>
  );
};

export default PicklistDetail;
